var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBfidBroker4Icon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6894 14.1969C20.1219 12.4691 18.6275 11.3072 16.7437 11.3072C14.1437 11.3072 12.3503 13.3038 12.3491 16.0153C12.3491 18.6962 14.1719 20.6928 16.7728 20.6928C18.6578 20.6928 20.1509 19.5006 20.6891 17.7725H24.4566C23.7684 21.4972 20.66 24 16.7741 24C12.1719 24 8.73438 20.6041 8.73438 16.0153C8.73438 11.4266 12.26 8 16.7741 8C20.7491 8 23.7969 10.5028 24.4844 14.1969H20.6894Z",
    fill: "#A2A2A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6094 32C25.4459 32 32.6094 24.8366 32.6094 16C32.6094 7.16344 25.4459 0 16.6094 0C7.77282 0 0.609375 7.16344 0.609375 16C0.609375 24.8366 7.77282 32 16.6094 32ZM32.0094 16C32.0094 24.5052 25.1146 31.4 16.6094 31.4C8.10419 31.4 1.20938 24.5052 1.20938 16C1.20938 7.49481 8.10419 0.6 16.6094 0.6C25.1146 0.6 32.0094 7.49481 32.0094 16Z",
    fill: "#A2A2A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfidBroker4Icon);
export default __webpack_public_path__ + "static/media/bfid-broker-4-icon.17f09a14b362d73f7b8682eccaf80c1d.svg";
export { ForwardRef as ReactComponent };